import { ModalDialog, Spinner, Typography } from "src/blitz"
import styles from "./AdvisorySuggestion.module.scss"
import { extractInstanceNumber } from "src/utils/CommonMethods"
import {
  CAUSES_TEXT,
  NOTES_TEXT
} from "src/components/buildingSummaryNewDesign/constants"
import { translate, TranslateComponent } from "src/common/translations"
const ServiceAdvisorySuggestion = (props: any) => {
  const {
    suggestions,
    suggestionModalConfig,
    loading = false,
    exceptionName,
    instance = null
  } = props
  let testName = props?.testName || props?.exceptionName || ""
  const instanceNumber =
    instance || extractInstanceNumber(exceptionName || testName)
  // Replace XX in both testName and exceptionName with the extracted circuit number
  if (instanceNumber) {
    // Use a safer replacement approach without template literals
    const safeInstanceNumber = String(instanceNumber).replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    )
    const replacement = " " + safeInstanceNumber
    testName = testName?.replace(/XX/gi, replacement)
  } else {
    testName = testName?.replace(/XX/gi, "")
  }

  return (
    <ModalDialog
      modalConfig={suggestionModalConfig}
      bodyClassName={styles.suggestionBody}
      customClassName={styles.customModalContent}
      footerClassName={styles.suggestionFooter}
    >
      <div className={styles.suggestionContent}>
        <Spinner loading={loading} className={styles.loadingContent} />
        {!loading && (
          <div className={styles.suggestionlist}>
            <Typography
              className={styles.namePargraph}
              tagType="p"
              styleType="p4"
              fontType="boldFont"
              translateText={true}
            >
              {testName}
            </Typography>
            <Typography
              tagType="p"
              styleType="p4"
              className={styles.suggestionDescription}
              translateText={true}
            >
              {suggestions?.description}
            </Typography>
            {suggestions?.notes && (
              <Typography
                tagType="p"
                styleType="p4"
                className={styles.suggestionNotes}
              >
                {NOTES_TEXT + suggestions?.notes}
              </Typography>
            )}
            {suggestions?.causes && (
              <Typography
                tagType="p"
                styleType="p4"
                fontType="boldFont"
                className={styles.nameHeading}
                translateText={true}
              >
                {CAUSES_TEXT}
              </Typography>
            )}
            <SuggestionData data={suggestions?.causes} />
          </div>
        )}
      </div>
    </ModalDialog>
  )
}
const SuggestionData = ({ data }) => {
  if (!data) return null
  return (
    <ul>
      {data?.map((item: any, index: number) => (
        <li key={index} className={styles?.subCausesListStyle}>
          <TranslateComponent>{item?.name}</TranslateComponent>
          <SuggestionData data={item?.causes} />
        </li>
      ))}
    </ul>
  )
}

export default ServiceAdvisorySuggestion
